// state
import type { RootState } from 'src/state';

// material
import { useSelector } from 'react-redux';

import Button from '@mui/material/Button';

// hooks
import { useTranslate } from 'src/locales';
import { selectUser } from 'src/state/user/selectors';

// ----------------------------------------------------------------------

export default function SubscriptionUpgradeButton({ plan }: { plan: 'pro' | 'basic' }) {
  const { t } = useTranslate();
  const user = useSelector(selectUser);
  const displayInterval = useSelector((state: RootState) => state.subscription.displayInterval);

  return (
    <Button
      variant="contained"
      fullWidth
      onClick={() => {
        if ((window as any).fastspring && (window as any).fastspring.builder) {
          (window as any).fastspring?.builder?.reset();
          switch (plan) {
            case 'pro':
            default:
              (window as any).fastspring?.builder?.add(
                displayInterval === 'monthly' ? 'pro' : 'pro-yearly'
              );
              break;
          }

          (window as any).fastspring?.builder?.tag({ userId: user?.id });
          (window as any).fastspring?.builder?.recognize({
            email: user?.email,
            firstName: user?.firstName,
            lastName: user?.lastName,
            userId: user?.id,
          });
          (window as any).fastspring?.builder?.checkout();
        }
      }}
    >
      {t('Subscribe')}
    </Button>
  );
}
